import React, { useState, useEffect } from "react";
import { useVsiAppContext } from "../../../stores/VsiApp";
import { useSearchParams } from "react-router-dom";
import { useDataWithRoute, useTitleFromComponent } from "../../../utils/hooks";
import {
  VsiBubble,
  VsiH4,
  VsiH5,
  VsiHr,
  VsiLgText,
  VsiMedLabel,
  VsiXLText
} from "../../../styled/App.styled";
import AtAGlance from "../../../components/AtAGlance";
import VsiLabeledSelect from "../../../components/VsiLabeledSelect";
import { forecastWithRate, formatDualAxisStockChartConfig, formatStockChartConfig } from "../../../utils/Helpers";
import Stockchart from "../../../components/Stockchart";
import { ButtonGroup, Button, Row, Col, Card } from "reactstrap";
import { vsiRed, vsiGreen } from "../../../utils/themeStyles";
import FlexChart from "../../../components/FlexChart";

const cloudResourceTopAag = [
  // {
  // 	"field": "resource_group",
  // 	// "icon": true,
  // 	"mobile": true
  // },
  {
    "field": "geography",
    // "icon": true,
    "mobile": true
  },
  {
    "field": "subscription",
    "style": {
      "color": "blue"
    },

    "mobile": true
  },
  {
    "field": "status",
    // "icon": true,
    "mobile": true
  },
  {
    "field": "size",
    // "icon": true,
    "mobile": true
  }
];
const cloudResourceSideAag = [
  {
    "field": "cost_per_month",
    // "icon": true,
    "mobile": true
  },
  {
    "field": "cost_per_year"
    // "icon": true,
  },
  {
    "field": "alerts",
    // "icon": true,
    "mobile": true
  },
  {
    "field": "service_name"
    // "icon": true,
  },
  {
    "field": "iops"
    // "icon": true,
  },
  {
    "field": "latency"
    // "icon": true,
  },
  {
    "field": "mbsec",
    // "icon": true,
    "mobile": true
  },
  {
    "field": "utilization"
    // "icon": true,
  },

  {
    "field": "pct_allocated"
    // "icon": true,
  },

  {
    "field": "pct_used",
    // "icon": true,
    "mobile": true
  },

  {
    "field": "days_to_80_pct_capacity"
    // "icon": true
  },
  {
    "field": "days_to_100_pct_capacity"
    // "icon": true
  },

  {
    "field": "iops_forecast"
    // "icon": true
  },

  {
    "field": "days_to_performance_threshold"
    // "icon": true
  }
];
const chartHeight = 450;
const margin = 3;

export default function CloudResourceGroupForecast({ context, title }) {
  const { isTabletScreen, theme, client, periodId } = useVsiAppContext();

  const [searchParams, setSearchParams] = useSearchParams();
  useTitleFromComponent(`${context} / ${title}`);

  let route = `/api/v6/report/cloud_resource_group_details_proc?client_id=${client.clientId}&period_id=${periodId}`;
  const resourceGroup = searchParams.get("resource_group");
  if (resourceGroup) {
    route += `&resource_group=${encodeURI(resourceGroup)}`;
  }
  const [data, { isLoading }] = useDataWithRoute(route);

  const [allGroups, setAllGroups] = useState(data?.recordsets?.[3]?.map?.(group => ({
    value: group.resource_group,
    label: group.resource_group
  })) || []);
  const [selectedGroup, setSelectedGroup] = useState(allGroups?.[0] || {});

  const [budgetTrend, setBudgetTrend] = useState([]);

  const [capacityTrend, setCapacityTrend] = useState([]);
  const [capacityTrendConfig, setCapacityTrendConfig] = useState({});
  const [capacityTrendType, setCapacityTrendType] = useState("used");

  const [costRecs] = useState([]);
  const [opRecs] = useState([]);

  const [actualCost, setActualCost] = useState(0);
  const [forecastedCost, setForecastedCost] = useState(0);

  function updateCapacityTrend() {
    const capacityArr = [
      {
        name: "Memory",
        field: capacityTrendType === "used" ? "memory_used" : capacityTrendType === "total" ? "total_memory" : "memory_used_pct",
        yAxis: 0
      },
      {
        name: "Disk",
        field: capacityTrendType === "used" ? "disk_used" : capacityTrendType === "total" ? "total_disk" : "disk_used_pct",
        yAxis: 0
      }
    ];

    const yAxis = [
      {
        title: {
          text: capacityTrendType !== "percent" ? "GB" : "% Used"
        },
        opposite: false
      }
    ];

    if (capacityTrendType !== "percent") {
      yAxis.push({
        title: {
          text: "GHz"
        },
        opposite: true
      });
      capacityArr.push(
        {
          name: "CPU",
          field: capacityTrendType === "used" ? "cpu_used" : capacityTrendType === "total" ? "total_cpu" : "cpu_used_pct",
          yAxis: capacityTrendType === "percent" ? 0 : 1
        }
      );
    }

    const series = formatDualAxisStockChartConfig(data?.recordsets?.[2] || [], capacityArr).series;
    setCapacityTrend(series);
    setCapacityTrendConfig({ yAxis });
  }

  function updateBudgetTrend() {
    const budgetTrend = (data?.recordsets?.[1] ?? []);
    const budgetData = forecastWithRate(budgetTrend || [], ["total_cost", "budget"]);

    const allSeriesData = formatStockChartConfig(budgetData || [], [
      {
        type: "areaspline",
        name: "Accumulated Cost",
        field: "total_cost",
        zoneAxis: "x",
        zones: [{
          value: Date.parse(
            budgetTrend?.[budgetTrend.length - 1]?.collection_date?.split?.("T")?.[0]
          )
        },
          {
            dashStyle: "Dash"
          }],
        disableMarker: true,
        colorFilter: {
          name: "forecast"
        }
      },
      {
        type: "spline",
        name: "Monthly Budget",
        field: "budget",
        zoneAxis: "x",
        zones: [{
          value: Date.parse(
            budgetTrend?.[budgetTrend.length - 1]?.collection_date?.split?.("T")?.[0]
          )
        },
          {
            dashStyle: "Dash"
          }],
        disableMarker: true
      }
    ]);
    setBudgetTrend(allSeriesData.series);
    setActualCost(budgetTrend?.[budgetTrend?.length - 1]?.total_cost || 0);
    setForecastedCost(budgetData?.find?.(({ collection_date }) => {
      return 0 > Date.now() - new Date(collection_date);
    })?.total_cost || 0);
  }

  useEffect(() => {
    if (allGroups.length < 1 && data?.recordsets?.[3]?.length) {
      setAllGroups(data?.recordsets?.[3]?.map?.(group => ({
        value: group.resource_group,
        label: group.resource_group
      })) || []);
      let groupToSet = data?.recordsets?.[3] ? {
        value: data?.recordsets?.[3]?.[0]?.resource_group,
        label: data?.recordsets?.[3]?.[0]?.resource_group
      } : {};
      setSelectedGroup(groupToSet);
    }
    updateBudgetTrend();
    updateCapacityTrend();

  }, [data, allGroups]);

  useEffect(() => {
    updateCapacityTrend();
  }, [capacityTrendType]);

  const onUnitChange = (selectedUnit) => {
    setSelectedGroup(selectedUnit);
    setSearchParams({
      resource_group: encodeURI(selectedUnit.value)
    }, { replace: true });
  };

  const onCapBtnClick = e => {
    const { name } = e.target;
    if (name !== capacityTrendType) {
      setCapacityTrendType(name);
    }
  };

  return (
    <Card className={`report-card p-2 nav-card-${theme}`}>
      <VsiH4>Cloud Resource Group Forecast</VsiH4>

      <Row>
        <Col xs={12} lg={10}>
          <VsiBubble autobotName="GeneralAtAGlance" unit={selectedGroup.value} autobotInfo={{
            data: {
              data: data?.recordsets?.[0]?.[0],
              config: cloudResourceTopAag
            }
          }}>
            <Row>
              <Col xs={2}>
                <VsiLabeledSelect isDisabled={isLoading}
                                  isLoading={isLoading}
                                  options={allGroups}
                                  label={"Resource Group"}
                                  onChange={onUnitChange}
                                  style={{
                                    position: "fixed"
                                  }}
                                  defaultValue={selectedGroup} />
              </Col>
              <Col xs={10}>
                <AtAGlance data={data?.recordsets?.[0]?.[0] || {}}
                           size={"lg"}
                           config={cloudResourceTopAag} />
              </Col>
            </Row>
          </VsiBubble>
          <VsiBubble
            className={`mt-${margin}`}
            autobotName="FlexChart"
            unit={selectedGroup.value}
            autobotInfo={{ data: budgetTrend, yAxis: { title: { text: "$USD" } }, actualCost, forecastedCost }}>
            {/*<VsiH5 className={"pb-3"}>Budget Forecast</VsiH5>*/}
            <Row>
              <Col xs={6} md={3} lg={2} className={"d-flex flex-column align-items-start"}>
                <VsiMedLabel>Actual Cost</VsiMedLabel>
                <VsiXLText>
                  ${actualCost.toFixed(2)}
                </VsiXLText>
              </Col>
              <Col xs={6} md={3} lg={2} className={"d-flex flex-column align-items-start"}>
                <VsiMedLabel>1 Month Forecast</VsiMedLabel>
                <VsiXLText>
                  ${forecastedCost.toFixed(2)}
                </VsiXLText>
              </Col>
            </Row>
            <FlexChart series={budgetTrend}
                       height={chartHeight}
                       title={"Budget Forecast"}
                       config={{
                         colors: [vsiGreen, vsiRed],
                         plotOptions: {
                           series: {
                             dashStyle: "dash"
                           }
                         },
                         yAxis: {
                           title: {
                             text: "$USD"
                           }
                         }
                       }} />
          </VsiBubble>
          <VsiBubble
            className={`mt-${margin}`}
            autobotName="Stockchart"
            unit={selectedGroup.value}
            autobotInfo={{
              secondaryMetric: [capacityTrendType], data: capacityTrend, lines: capacityTrend?.map(line => {
                return line?.name;
              }), yAxes: capacityTrendConfig?.["yAxis"]
            }}>
            {/*<VsiH5 className={"pb-3"}>Capacity Trend</VsiH5>*/}
            <ButtonGroup>
              <Button name="used"
                      onClick={onCapBtnClick}
                      active={capacityTrendType === "used"}
                      disabled={capacityTrendType === "used"}>Used</Button>
              <Button name="total"
                      onClick={onCapBtnClick}
                      active={capacityTrendType === "total"}
                      disabled={capacityTrendType === "total"}>Total</Button>
              <Button name="percent"
                      onClick={onCapBtnClick}
                      active={capacityTrendType === "percent"}
                      disabled={capacityTrendType === "percent"}>% Used</Button>
            </ButtonGroup>
            <Stockchart series={capacityTrend}
                        height={chartHeight}
                        title={"Capacity Trend"}
                        config={capacityTrendConfig} />
          </VsiBubble>
          <Row className={`mt-${margin}`}>
            <Col xs={12}>
              <Row>
                {/* don't show unless there is data */}
                <Col xs={12} lg={6}>
                  {costRecs.length < 1 ? null :
                    <VsiBubble autobotName="CostRecommendations" unit={selectedGroup.value}>
                      <VsiH5>Cost Recommendations</VsiH5>
                      <VsiHr />
                      <VsiLgText>{costRecs.length < 1 ?
                        "No recommendations at this time." : null}</VsiLgText>
                    </VsiBubble>
                  }
                </Col>
                <Col xs={12} lg={6}>
                  {costRecs.length < 1 ? null :
                    <VsiBubble autobotName="OperationalRecommendations" unit={selectedGroup.value}>
                      <VsiH5>Operational Recommendations</VsiH5>
                      <VsiHr />
                      <VsiLgText>{opRecs.length < 1 ?
                        "No recommendations at this time." : null}</VsiLgText>
                    </VsiBubble>
                  }
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={2}>
          <VsiBubble
            className={"h-100"}
            style={{ overflowY: "auto" }}
            autobotName="DetailsAtAGlance"
            unit={selectedGroup.value}
            noAutobot={!data?.recordsets?.[0]?.[0]?.cost_per_month}
            autobotInfo={{
              data: {
                data: data?.recordsets?.[0]?.[0]
              }
            }}>
            <AtAGlance data={data?.recordsets?.[0]?.[0] || {}}
                       size={"lg"}
                       orient={isTabletScreen ? "horizontal" : "vertical"}
                       config={cloudResourceSideAag} />
          </VsiBubble>
        </Col>
      </Row>
    </Card>
  );
}
